// 連線狀態判斷的純邏輯——刻意獨立於 network.js 本身（那支依賴 Vue 的
// reactive，這裡零 import，方便 tests/unit 直接測，不需要在測試裡假造
// Vue 的 reactive 或用 vm context 模擬 import）。
//
// network.js／NetworkStatusWidget.vue／Login.vue 都只是把這裡的判斷結果
// 綁到畫面或拿去下決定，規則本身只寫在這一份，不要在呼叫端各自重複判斷。
'use strict'

/** 全站 `networkState.online` 的定義：網卡有連線＋站台可達，兩者都要成立。 */
export function resolveOnline(networkCardOnline, serverReachable) {
  return !!networkCardOnline && !!serverReachable
}

/**
 * 頁尾徽章／登入頁要顯示的連線狀態，四態互斥：
 *   'offline-login'  —— 有離線登入標記，不論網路狀態如何都優先顯示這個
 *   'offline-network' —— 網卡本身沒有連線（navigator.onLine === false）
 *   'offline-server'  —— 網卡有連線，但站台探測不到（server 掛了／擋掉了）
 *   'online'           —— 網卡有連線且站台可達
 */
export function resolveConnectionState(networkCardOnline, serverReachable, hasOfflineLoginMarker) {
  if (hasOfflineLoginMarker) return 'offline-login'
  if (!networkCardOnline) return 'offline-network'
  if (!serverReachable) return 'offline-server'
  return 'online'
}

/** 徽章文字——三態（'離線登入中' 蓋掉了原本網路/站台的兩種離線用語）。 */
export function connectionStateLabel(state) {
  if (state === 'offline-login') return '離線登入中'
  if (state === 'online') return '連線中'
  return '離線中'
}

/** 徽章 title（滑鼠停留說明）——跟 label 分開維護，因為「離線中」這個
 * label 底下實際有兩種不同原因，需要 title 講清楚是哪一種。 */
export function connectionStateTitle(state) {
  switch (state) {
    case 'online': return '目前連線正常'
    case 'offline-network': return '目前沒有網路'
    case 'offline-server': return '無法連線到伺服器'
    case 'offline-login': return '離線登入中，尚未建立伺服器連線'
    default: return ''
  }
}

/** 登入頁離線橫幅要顯示的原因文字——跟徽章 title 語意相同但措辭給登入頁用
 * （登入頁不需要「離線登入中」這個狀態，那正是登入頁本身要處理的動作，不是
 * 描述現況的文字），所以刻意不共用 connectionStateTitle()。 */
export function offlineReasonText(networkCardOnline, serverReachable) {
  if (!networkCardOnline) return '目前沒有網路'
  if (!serverReachable) return '無法連線到伺服器'
  return ''
}
